module.exports = __webpack_public_path__ + "img/usuario-sem-foto.13dd6cab.png";